module.exports = __webpack_public_path__ + "img/81ne.bd3c9671.svg";